import { useEffect, useState, useContext, createContext } from "react";
import api from "../services/api";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState({});
    const [loading, setLoading] = useState(true);
    const [signed, setSigned] = useState(false);

    async function Login({ email, password }) {
        setLoading(true);
        return await api.post('login', {
            email: email,
            password: password
        });
    }

    const Logout = () => {
        localStorage.removeItem('@App:token');
        
        setSigned(false);
    }

    useEffect(() => {
        const token = localStorage.getItem('@App:token');

        if (token) {
            api.get('validate').then((response) => {
                setUser(response.data);
                setSigned(true);
                setLoading(false);
            }).catch((error) => {
                setLoading(false);
                localStorage.removeItem('@App:token');
                setSigned(false);
            });
        } else {
            localStorage.removeItem('@App:token');
            setSigned(false);
            setLoading(false);
        }
    }, []);
    

    return (
        <AuthContext.Provider value={{ loading, Login, Logout, setLoading, signed, setSigned, user, setUser }}>
            {children}
        </AuthContext.Provider>
    );
}

export default AuthContext;

export function useAuth() {
    return useContext(AuthContext);
}